export const getReviewStatusButtonBackground = Object.freeze({
  "not sent": "not-sent",
  "pending": "review-pending",
  "received": "review-recieved",
});
